/**
 * The handful of visual tokens shared by the branded launch screens.
 *
 * SplashScreen and OfflineLaunchScreen are two states of ONE screen from the
 * player's side: the app either comes up or explains why it cannot. They have
 * to sit on exactly the same ground, so the values live here once instead of
 * being copied and drifting apart the first time either is restyled.
 */

/** The launch backdrop. Every full-screen boot state paints this. */
export const SPLASH_BACKDROP = 'linear-gradient(180deg, #1c1a14 0%, #12100c 100%)';

/** Hijack amber, used for the byline and for the primary action. */
export const SPLASH_ACCENT = '#E98C26';

export const SPLASH_FONT = "'Outfit', sans-serif";

/**
 * Logo width, identical on both screens on purpose. The offline screen can
 * replace the splash mid-launch, and a logo that changes size across that
 * swap is the kind of jump that makes one screen look like two. Landscape is
 * handled by letting the offline screen's content scroll rather than by
 * shrinking the mark.
 */
export const SPLASH_LOGO_WIDTH = '200px';
